export const VENDOR_TYPES = [
  { value: 'supplier', label: 'Supplier' },
  { value: 'contractor', label: 'Contractor' },
  { value: 'service_provider', label: 'Service Provider' },
  { value: 'freelancer', label: 'Freelancer' },
  { value: 'influencer', label: 'Influencer' },
  { value: 'agency', label: 'Agency' },
  { value: 'consultant', label: 'Consultant' },
  { value: 'other', label: 'Other' }
];

export const PAYMENT_METHODS = [
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'cash', label: 'Cash' },
  { value: 'instapay', label: 'InstaPay' },
  { value: 'paypal', label: 'PayPal' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'check', label: 'Check' },
  { value: 'cryptocurrency', label: 'Cryptocurrency' },
  { value: 'other', label: 'Other' }
];

export const VENDOR_CATEGORIES = {
  influencer: [
    { value: 'fashion', label: 'Fashion' },
    { value: 'beauty', label: 'Beauty' },
    { value: 'lifestyle', label: 'Lifestyle' },
    { value: 'travel', label: 'Travel' },
    { value: 'food', label: 'Food' },
    { value: 'fitness', label: 'Fitness' },
    { value: 'technology', label: 'Technology' },
    { value: 'gaming', label: 'Gaming' },
    { value: 'education', label: 'Education' },
    { value: 'business', label: 'Business' },
    { value: 'finance', label: 'Finance' },
    { value: 'entertainment', label: 'Entertainment' },
    { value: 'music', label: 'Music' },
    { value: 'art', label: 'Art' },
    { value: 'photography', label: 'Photography' },
    { value: 'automotive', label: 'Automotive' },
    { value: 'sports', label: 'Sports' },
    { value: 'health', label: 'Health' },
    { value: 'parenting', label: 'Parenting' },
    { value: 'home_decor', label: 'Home Decor' },
    { value: 'diy', label: 'DIY' },
    { value: 'pets', label: 'Pets' }
  ],
  service: [
    { value: 'marketing', label: 'Marketing' },
    { value: 'design', label: 'Design' },
    { value: 'development', label: 'Development' },
    { value: 'consulting', label: 'Consulting' },
    { value: 'accounting', label: 'Accounting' },
    { value: 'legal', label: 'Legal' },
    { value: 'logistics', label: 'Logistics' },
    { value: 'production', label: 'Production' },
    { value: 'printing', label: 'Printing' },
    { value: 'event_management', label: 'Event Management' },
    { value: 'pr', label: 'PR' },
    { value: 'translation', label: 'Translation' }
  ],
  general: [
    { value: 'other', label: 'Other' }
  ]
};

export const ALL_CATEGORIES = [
  ...VENDOR_CATEGORIES.influencer,
  ...VENDOR_CATEGORIES.service,
  ...VENDOR_CATEGORIES.general
];

export const SOCIAL_PLATFORMS = [
  { value: 'instagram', label: 'Instagram', icon: '📷' },
  { value: 'tiktok', label: 'TikTok', icon: '🎵' },
  { value: 'youtube', label: 'YouTube', icon: '📹' },
  { value: 'twitter', label: 'Twitter', icon: '🐦' },
  { value: 'facebook', label: 'Facebook', icon: '👤' },
  { value: 'linkedin', label: 'LinkedIn', icon: '💼' }
];

export const PAYMENT_TERMS = [
  { value: 0, label: 'Immediate' },
  { value: 7, label: 'Net 7' },
  { value: 15, label: 'Net 15' },
  { value: 30, label: 'Net 30' },
  { value: 45, label: 'Net 45' },
  { value: 60, label: 'Net 60' },
  { value: 90, label: 'Net 90' }
];